// AI Generated
import { Component, Input, OnInit } from '@angular/core';
import { ParamService } from '@monsido/core/param/param.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { DEFAULTS } from '@monsido/ng2/core/constants/defaults.constant';
import moment from 'moment';

@Component({
    selector: 'page-details-section-statistics',
    standalone: false,
    template: `
        <div class="alert alert-info px-3 my-0" *ngIf="'page_statistics' | hasDemoAccess" translate>
            This section is using sample data
        </div>
        <div class="row page-details-statistics">
            <div class="col-48 section-header d-flex align-items-center my-6">
                <h3 class="font-weight-300 ml-3 my-0 mr-auto">
                    <span class="mr-2 text-link" [ngClass]="['MENUES', 'STATISTICS'] | monIcons" aria-hidden="true"></span>
                    <span translate>Page Statistics</span>
                </h3>
                <div>
                    <date-picker
                        [(date)]="date"
                        [monDateFormat]="dateFormat"
                        (dateChange)="updateDateRange()"
                        [options]="datePickerOptions"
                    >
                    </date-picker>
                </div>
            </div>
            <div class="col-48 col-md-32">
                <page-details-section-statistics-summary
                    [page]="page"
                    [startDate]="date.startDate"
                    [endDate]="date.endDate">
                </page-details-section-statistics-summary>
            </div>
            <div class="col-48 col-md-16">
                <page-details-section-statistics-traffic-sources
                    class="block pr-2"
                    [page]="page"
                    [startDate]="date.startDate"
                    [endDate]="date.endDate">
                </page-details-section-statistics-traffic-sources>
            </div>
        </div>
    `,
})
export class PageDetailsSectionStatisticsComponent implements OnInit {
    @Input() page: any;
    @Input() active: any;

    public date: any;
    public dateFormat: string = DEFAULTS.DATE_FORMAT;
    public datePickerOptions: any;

    constructor (
        private paramService: ParamService,
        private dateRangeService: DateRangeService,
    ) {}

    ngOnInit (): void {
        this.active = this.active || 'summary';
        this.page = this.page || {};
        this.date = this.dateRangeService.setRangeDates();
        this.datePickerOptions = {
            maxDate: moment(),
        };
    }

    updateDateRange (): void {
        this.paramService.setParams({
            from: moment(this.date.startDate),
            to: moment(this.date.endDate),
        });
    }
}
